import React from 'react';
import { withApollo, WithApolloClient } from '@apollo/client/react/hoc';
import { Field, FormikValues, FormikActions } from 'formik';

const EmployerBlacklistQuery = require('buyside/graphql/queries/EmployerBlacklist.graphql');
const EmployerSearchQuery = require('buyside/graphql/queries/EmployerSearch');

import AutocompleteField from 'buyside/components/presentation/Form/Field/AutocompleteField/autocompleteField';

interface EAProps extends PickedFormikActions {
  analyticsTag?: string;
  label: string;
  locked?: boolean;
  name: string;
  placeholder?: string;
}

interface EAState {
  loading: boolean;
  query: string;
  suggestions: Suggestion[];
  employerBlacklist: string[];
}

type PickedFormikActions = Pick<FormikActions<FormikValues>, 'setFieldError' | 'setFieldValue'>;

interface Suggestion {
  displayName: string;
  name: string;
}

interface BlacklistData {
  employerBlacklist: string[];
}

interface EmployerData {
  employerSearch: Suggestion[];
}

interface QueryVariables {
  query: string;
}

export class EmployerAutocomplete extends React.PureComponent<
  WithApolloClient<Omit<EAProps, 'client'>>,
  EAState
> {
  constructor(props: WithApolloClient<Omit<EAProps, 'client'>>) {
    super(props);
    this.state = { loading: false, query: '', suggestions: [], employerBlacklist: [] };
    this.selectIntercept = this.selectIntercept.bind(this);
    this.changeIntercept = this.changeIntercept.bind(this);
  }

  componentDidMount(): void {
    const { client } = this.props;
    if (client) {
      client
        .query<BlacklistData, QueryVariables>({ query: EmployerBlacklistQuery })
        .then((res): void => {
          const blacklist = res.data.employerBlacklist.map((item: string): string =>
            item.toLowerCase()
          );
          this.setState({ employerBlacklist: blacklist });
        });
    }
  }

  selectIntercept(_value: FormikValues, selectedItem: Suggestion): void {
    const { name, setFieldValue, setFieldError } = this.props;
    const { employerBlacklist } = this.state;
    const isFakeCompany = employerBlacklist.includes(selectedItem.name.toLowerCase());
    if (isFakeCompany) {
      return setFieldError(name, 'Please enter a valid employer.');
    } else {
      setFieldValue(name, selectedItem.name);
    }
  }

  changeIntercept(query: string): void {
    const { client } = this.props;
    if (client) {
      this.setState({ loading: true, query }, (): void => {
        client
          .query<EmployerData, QueryVariables>({
            query: EmployerSearchQuery,
            variables: { query }
          })
          .then((res): void => {
            const newEmployer = {
              displayName: `+ Add New Employer (${this.state.query})`,
              name: this.state.query
            };
            this.setState({
              loading: false,
              suggestions: [newEmployer].concat(res.data.employerSearch)
            });
          });
      });
    }
  }

  render(): React.ReactElement {
    const autosuggestOptions = {};
    return (
      <Field
        analyticsTag={this.props.analyticsTag}
        autosuggestOptions={autosuggestOptions}
        changeIntercept={this.changeIntercept}
        component={AutocompleteField}
        formatSuggestion={(
          suggestion: Suggestion
        ): Suggestion['displayName'] | Suggestion['name'] =>
          suggestion.displayName || suggestion.name
        }
        getSuggestionValue={(suggestion: Suggestion): Suggestion['name'] => suggestion.name}
        handleSuggestionsClearRequested={(): void => this.setState({ suggestions: [] })}
        debounce
        isWide
        label={this.props.label}
        loading={this.state.loading}
        locked={this.props.locked}
        name={this.props.name}
        placeholder={this.props.placeholder}
        selectIntercept={this.selectIntercept}
        suggestions={this.state.suggestions}
      />
    );
  }
}

export default withApollo(EmployerAutocomplete);
